<template>
	<div class="global-audio-container" :class="{'alternate-mode': playerHidden, 'tracklist-show' : showPlaylist}" v-if="playlist">
		<transition name="fade">
			<div class="gap-tracklist" :class="{'show-tracklist': showPlaylist}">
				<p class="gap-track" v-for="(track, index) in tracks" :key="index" @click="playTrack(track)">
					<fa-icon v-if="playingTrack === track" class="faicon" size="xs" icon="play" />
					<span class="gap-trackname" :class="{'gap-trackname-active': playingTrack === track}">{{ translateTrackName(track) }}</span>
				</p>
			</div>
		</transition>
		<div class="gap-player-container">
			<span v-for="(track, index) in tracks" :key="index" @click="playTrack(track)">
				<div class="gap-player" v-if="playingTrack === track">
					<audio-player :id="track.id" :autoplay="canAutoplay"/>
				</div>
			</span>
		</div>
		<div class="gap-controls">
			<span class="gap-tracks-numbers">
				{{ currentOf }}/{{ tracks.length }}
			</span>
			<span class="gap-toggle-playlist">
				<fa-icon class="faicon" icon="list" @click="togglePlaylist"/>
			</span>
			<span class="gap-toggle-player" @click="togglePlayer" :class="{border: playerHidden}">
				<fa-icon class="faicon" v-show="playerHidden" icon="music" />
				<fa-icon class="faicon" v-show="!playerHidden" icon="angle-left" />
			</span>
		</div>
	</div>
</template>

<script>
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';
import featureSetLoaderMixin from '@/store/modules/featureSet/feature-set-loader';
import AudioPlayer from './AudioPlayer.vue';

export default {
	components: { AudioPlayer },
	mixins: [staticDataLoaderMixin, contentDataLoaderMixin, featureSetLoaderMixin],
	data() {
		return {
			playlist: null,
			tracks: null,
			playingTrack: null,
			showPlaylist: false,
			playerHidden: false,
			canAutoplay: false,
		};
	},
	created() {
		if (this.generalSettings.playlist) {
			const playlistObject = this.getContentById('playlists', this.generalSettings.playlist);
			if (playlistObject) {
				this.playlist = playlistObject;
				this.tracks = this.playlist.fields.data.map(e => this.getContentById('media', e));
				// eslint-disable-next-line prefer-destructuring
				this.playingTrack = this.tracks[0];
				this.playerHidden = this.featureSet.globalAudioPlayer.closedOnHomePage && this.$router.currentRoute.fullPath === '/home';
			}
		}
	},
	watch: {
		$route(to) {
			this.playerHidden = this.featureSet.globalAudioPlayer.closedOnHomePage && to.fullPath === '/home';
		},
	},
	computed: {
		currentOf() {
			return this.tracks.indexOf(this.playingTrack) + 1;
		},
		translateTrackName() {
			return t => JSON.parse(t.name)[this.language];
		},
	},
	methods: {
		togglePlaylist() {
			this.showPlaylist = !this.showPlaylist;
		},
		togglePlayer() {
			this.playerHidden = !this.playerHidden;
		},
		playTrack(t) {
			// console.log(t);
			this.canAutoplay = true;
			this.showPlaylist = false;
			this.playingTrack = t;
			// this.$refs.playerSingleton.play();
		},
	},

};
</script>

<style src="@/styles/components/GlobalAudio/GlobalAudio.less" lang="less" scoped></style>
